// extracted by mini-css-extract-plugin
export default {"leftBorder":"space-selector-dropdown-options_leftBorder__gnMop"};